import AssetHelper from "./asset.helper";
import PositionHelper from "./position.helper";
import NotificationHandler from "../NotificationHandler";
import Player from "@/prefabs/core/Player";
import GameplayPanels from "@/prefabs/scene/Gameplay/Panels";
import { NotificationType } from "@/types/Notification";
var init = function (scene) {
    // init player
    var position = PositionHelper.run();
    scene.player = new Player(scene, {
        id: scene.params.user.id,
        username: scene.params.user.username,
        type: 0,
        position: position,
        game: {
            score: 0,
            level: 0,
            exp: 0,
            count_kill: 0,
            count_strike: 0,
            is_alive: true,
        },
    });
    // init camera
    scene.camera = scene.cameras.main;
    scene.camera.startFollow(scene.player, true);
    NotificationHandler.getInstance().on(NotificationType.DEATH, function (detail) {
        var is_alive = detail.is_alive;
        if (is_alive) {
            var position_1 = PositionHelper.run();
            scene.player.setPosition(position_1.x, position_1.y);
            scene.player.revive();
            GameplayPanels.getInstance().onPlayerDeath(true);
            return;
        }
        GameplayPanels.getInstance().onPlayerDeath(false);
        scene.player.death(function () {
            scene.player.NOTIFY_ALIVE();
        });
    });
    AssetHelper.loadProfile(scene, scene.params.user);
};
var PlayerHelper = { init: init };
export default PlayerHelper;
